import React, { useState } from 'react'

import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(theme => ({
  labelWrapper: {
    margin: '15px 0',
    display: 'flex',
    position: 'relative',
    cursor: 'pointer',
    fontSize: 22,
    lineHeight: '24px',
    clear: 'both',
    marginBottom: '15px',
    alignItems: 'center',
  },
  labelParagraph: {
    margin: '0 0 0 10px',
    fontSize: 12,
  },
  labelInput: {
    position: 'absolute',
    opacity: 0,
    cursor: 'pointer',
  },
  checkboxSquare: {
    flexShrink: 0,
    display: 'inline-block',
    height: 18,
    width: 18,
    backgroundColor: 'transparent',
    borderRadius: theme.borderRadius,
    transition: 'all 0.3s ease-out',
    border: '1px solid #CCCCCC',
    '& ::after': {
      position: 'absolute',
      content: '',
      left: 12,
      top: 12,
      height: 0,
      width: 0,
      borderRadius: theme.borderRadius,
      border: 'solid #009BFF',
      borderWidth: '0 3px 3px 0',
      transform: 'rotate(0deg) scale(0)',
      opacity: 1,
      transition: 'all 0.3s ease-out',
    },
    '& ::before': {
      position: 'absolute',
      content: '',
      left: 10,
      top: 10,
      width: 0,
      height: 0,
      borderRadius: theme.borderRadius,
      border: '1px solid #007AC3',
      transform: 'scale(0)',
    },
  },
  checkboxSquareActive: {
    backgroundColor: '#007AC3',
    borderRadius: theme.borderRadius,
    transform: 'rotate(0deg) scale(1)',
    flexShrink: 0,
    opacity: 1,
    border: '1px solid #007AC3',

    '& ::before': {
      left: -3,
      top: -3,
      width: 18,
      height: 18,
      borderRadius: theme.borderRadius,
      transform: 'scale(3)',
      opacity: 0,
      zIndex: 999,
      transition: 'all 0.3s ease-out',
    },
  },
  error: {
    '& .error': {
      display: 'flex',
      alignItems: 'center',
      fontSize: 12,
      paddingTop: 7,
      color: '#EE2049',
    },
    '& .error img': {
      width: 12,
      height: 12,
      marginTop: 2,
      marginRight: 5,
    },
  },
}))

const FormCheckbox = ({ labelText, inputName, inputType, defaultValue, error, onChange }) => {
  const classes = useStyles()
  const [active, setActiveState] = useState(defaultValue)

  const CheckboxClasses = active
    ? `${classes.checkboxSquareActive} ${classes.checkboxSquare}`
    : classes.checkboxSquare

  return (
    <div className={`${error && classes.error}`}>
      <label className={`${classes.labelWrapper} ${error && classes.error}`}>
        <input
          className={classes.labelInput}
          type="checkbox"
          name={inputName}
          // checkboxSquareActive
          onClick={e => setActiveState(!active)}
          checked={defaultValue}
          onChange={e =>
            onChange({
              target: {
                name: inputName,
                value: e.target.checked,
              },
            })
          }
        />
        <span className={`${CheckboxClasses} ${error && classes.error}`}></span>
        <p className={`${classes.labelParagraph} ${error && classes.error}`}>{labelText}</p>
      </label>
      {error && error[0] !== null && (
        <div className="error">
          <img src="/themes/thrifty/assets/images/errorex.png" />
          {error.join(', ')}
        </div>
      )}
    </div>
  )
}

export default FormCheckbox
